import React from 'react'
import { Button, Typography, FormControl, IconButton } from '@mui/material'
import { Print, Close } from '@mui/icons-material'
import Dropdown from '../../ui/Dropdown/Dropdown'
import { StyledOptionsContainer } from './Print.styled'

interface PrintToolbarProps {
  title?: string
  onPrint: () => void
  onClose: () => void
  options: {
    orientation?: string
    pageSize?: string
  }
  setOptions: (options: any) => void
}

const PrintToolbar: React.FC<PrintToolbarProps> = ({
  title,
  onPrint,
  onClose,
  options,
  setOptions,
}) => {
  return (
    <StyledOptionsContainer>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>

      <FormControl
        variant="outlined"
        size="small"
        sx={{ mx: 1, minWidth: 120 }}
      >
        <Dropdown
          size="small"
          value={options.pageSize}
          label="Page Size"
          options={[
            { value: 'a4', label: 'A4' },
            { value: 'letter', label: 'Letter' },
          ]}
          onChange={(e) =>
            setOptions({ ...options, pageSize: e.target.value as string })
          }
        />
      </FormControl>

      <FormControl
        variant="outlined"
        size="small"
        sx={{ mx: 1, minWidth: 120 }}
      >
        <Dropdown
          size="small"
          value={options.orientation}
          label="Orientation"
          options={[
            { value: 'portrait', label: 'Portrait' },
            { value: 'landscape', label: 'Landscape' },
          ]}
          onChange={(e) =>
            setOptions({ ...options, orientation: e.target.value as string })
          }
        />
      </FormControl>

      <Button
        variant="contained"
        startIcon={<Print />}
        onClick={onPrint}
        sx={{ mx: 1 }}
      >
        Print
      </Button>

      <IconButton onClick={onClose} edge="end">
        <Close />
      </IconButton>
    </StyledOptionsContainer>
  )
}

export default PrintToolbar
